
import { Match, Show, Switch } from 'solid-js'
import { DateTime } from 'luxon';
import { CleanTime, daysOfWeekly, weekday } from 'Shared/common/Macros';
//import { EventCalendarSettings } from 'Shared/model/basic';

export function DateAsLabel(P)
//export function DateAsLabel(P:EventCalendarSettings & {options}) 
{	
	const hide = () => P.options?.user?.hideDetails ?? [];

	return (
		<Switch>
			<Match when={P.customLabel}>
				{P.customLabel}
			</Match>
			<Match when={P.frequency == 'once'}>
				<Show when={!hide().recordDate && P.startSingle}>
					{DateTime.fromISO(P.startSingle).toFormat('EEE, dd LLL')}
				</Show>
				<Show when={!hide().includes('startTime') && P.startSingle}>
					{' '}
					<CleanTime time={P.startSingle} />
				</Show>
			</Match>
			<Match when={P.frequency == 'daily'}>
				Every day
				<Show when={!hide().includes('startTime') && P.startTime}>
					{' '}
					<CleanTime time={P.startTime} />
				</Show>
			</Match>
			<Match when={P.frequency == 'weekly'}>
				{daysOfWeekly(P.weekdays)}

				<Show when={!hide().includes('startTime') && P.startTime}>
					{' '}
					<CleanTime time={P.startTime} />
				</Show>

				<Show when={!hide().includes('endTime') && P.endTime}>
					{' - '}
					<CleanTime time={P.endTime} />
				</Show>
			</Match>
			<Match when={P.frequency == 'monthly'}>
				{P.week}
				{' '}
				{weekday(P.weekday)} of month,

				<Show when={!hide().includes('startTime') && P.startTime}>
					{' '}
					<CleanTime time={P.startTime} />
				</Show>

				<Show when={!hide().includes('endTime') && P.endTime}>
					{' - '}
					<CleanTime time={P.endTime} />
				</Show>
			</Match>
		</Switch>
	);
}

